import { type MapSettingsStylesChangeData } from '~/store/mapSettings/mapStyles/mapSettingsMapStyles.state';

export const baseMapThemesStandard: MapSettingsStylesChangeData = [];
